import React, { Fragment, forwardRef } from "react";
import Image from './Image';
import { getModeName } from 'lib';

export default forwardRef((props: any, ref: any) => {
  const {
    checkAnswer,
    ...rest
  } = props;
  const composeMode = getModeName() === "compose";

  return (
    <Fragment>
    {
      checkAnswer || composeMode ?
      <Image {...rest} ref={ref} /> :
      null
    }
    </Fragment>
  )
});
